import { Button, Switch } from 'antd';

export const uploadFields = [
  {
    label: 'Application Form',
    name: 'applicationFormKey',
    require: true,
    message: 'Please upload the form',
    documentType: 'APPLICATION_FORM',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Company Registration Certificate',
    name: 'companyRegistrationCertificateKey',
    require: true,
    message: 'Please upload the certificate',
    documentType: 'COMPANY_REGISTRATION_CERTIFICATE',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Authorized Person Identity',
    name: 'authorizedPersonIdentityKey',
    require: true,
    message: 'Please upload an ID',
    documentType: 'AUTHORIZED_PERSON_IDENTITY',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Bod Resolution',
    name: 'bodResolutionKey',
    require: true,
    message: 'Please upload a document',
    documentType: 'BOD_RESOLUTION',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Personal Bank Account',
    name: 'personalBankAccountKey',
    require: true,
    message: 'Please upload a document',
    documentType: 'PERSONAL_BANK_ACCOUNT',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Company Constitution',
    name: 'companyConstitutionKey',
    message: 'Please upload a document',
    documentType: 'COMPANY_CONSTITUTION',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
];

export const fieldToPanelMappingForCorporateTrader = {
  tradingAccountType: '3',
  corporateAccountType: '4',
  applicationFormKey: '5',
  companyRegistrationCertificateKey: '5',
  authorizedPersonIdentityKey: '5',
  bodResolutionKey: '5',
  personalBankAccountKey: '5',
};

// Director Table
export const directorTable = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'NRC',
    dataIndex: 'nrcNo',
    key: 'nrcNo',
  },
  {
    title: 'Resident Address',
    dataIndex: 'residentialAddress',
    key: 'residentialAddress',
  },

  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <>
        <Button type={'link'} danger onClick={() => console.log('Call edit api')}>
          Edit
        </Button>
      </>
    ),
  },
];

// Authorized Person
export const authPersonTable = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'NRC',
    dataIndex: 'nrcNo',
    key: 'nrcNo',
  },
  {
    title: 'Designation',
    dataIndex: 'designation',
    key: 'designation',
  },
  {
    title: 'Signature',
    dataIndex: 'signature',
    key: 'signature',
    render: signature => (signature ? 'Yes' : 'No'), // how to show boolean value
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <>
        <Button type={'link'} danger onClick={() => console.log('Call edit api')}>
          Edit
        </Button>
      </>
    ),
  },
];

// Company Owner Table
export const companyOwnerTable = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'NRC',
    dataIndex: 'nrcNo',
    key: 'nrcNo',
  },
  {
    title: '% of Share Holders',
    dataIndex: 'percentOfShareholders',
    key: 'percentOfShareholders',
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <>
        <Button type={'link'} danger onClick={() => console.log('Call edit api')}>
          Edit
        </Button>
      </>
    ),
  },
];

export const directorFormFields = [
  {
    label: 'Name',
    name: 'name',
    type: 'input',
  },
  {
    label: 'NRC',
    name: 'nrcNo',
    type: 'input',
  },
  {
    label: 'Resident Address',
    name: 'residentialAddress',
    type: 'input',
  },
];

export const authPersonFormFields = [
  {
    label: 'Name',
    name: 'name',
    type: 'input',
  },
  {
    label: 'NRC',
    name: 'nrcNo',
    type: 'input',
  },
  {
    label: 'Designation',
    name: 'designation',
    type: 'input',
  },
  {
    label: 'Signature',
    name: 'signature',
    type: 'switch',
  },
];

export const companyOwnerFormFields = [
  {
    label: 'Name',
    name: 'name',
    type: 'input',
  },
  {
    label: 'NRC',
    name: 'nrcNo',
    type: 'input',
  },
  {
    label: '% of Shareholders',
    name: 'percentOfShareholders',
    type: 'number',
  },
];
